export default "__VITE_ASSET__qMtvjusN__"